// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { useHistory, useLocation, Link } from 'react-router-dom'
// import ReactPaginate from 'react-paginate'
// import admindata from '../../components/admindata'
// import { apiRequest } from '../../apiServices/allApi'
// const $ = require('jquery')
// $.Datatable = require('datatables.net')
// // import "../transaction/imageview.css"

// export default function UserKyc () {
//   const [data, setData] = useState([])
//   const baseUrl = process.env.REACT_APP_API_BASE_URL;

//   const id = localStorage.getItem('id')

//   //use for pagination..
//   let [limit, setLimit] = useState(20)

//   const setpageLimit = event => {
//     let key = event.target.value
//     setLimit(key)
//   }
//   const [pageNumber, setPageNumber] = useState(0)
//   const [numberOfPages, setNumberOfPages] = useState(0)

//   //react paginate..
//   const handlePageClick = async data => {
//     let currentPage = data.selected + 1
//     setPageNumber(currentPage)
//   }


//   const All = async () => {
//     const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//   try {
//     const res = await apiRequest(  `aadharcard/all/all/all?page=${pageNumber}&_limit=${limit}`,"GET",null,headers)
//     setData(res.data.admin)
//           setNumberOfPages(res.data.totalPages)
//           // console.log(res.data.admin)
//           imageViewer()
//   } catch (error) {
//     //  console.log(e);
//   } finally {
//     // setLoading(false)
//   }
// }

//   useEffect(() => {
//     All()
//   }, [pageNumber, limit])

//   function imageViewer () {
//     let imgs = document.getElementsByClassName('img'),
//       out = document.getElementsByClassName('img-out')[0]
//     for (let i = 0; i < imgs.length; i++) {
//       if (!imgs[i].classList.contains('el')) {
//         imgs[i].classList.add('el')
//         imgs[i].addEventListener('click', lightImage)
//         function lightImage () {
//           let container = document.getElementsByClassName('img-panel')[i]
//           container.classList.toggle('img-panel__selct')
//         }

//         imgs[i].addEventListener('click', openImage)
//         function openImage () {
//           let imgElement = document.createElement('img'),
//             imgWrapper = document.createElement('div'),
//             imgClose = document.createElement('div'),
//             container = document.getElementsByClassName('img-panel')[i]
//           container.classList.add('img-panel__selct')
//           imgElement.setAttribute('class', 'image__selected')
//           imgElement.src = imgs[i].src
//           imgWrapper.setAttribute('class', 'img-wrapper')
//           imgClose.setAttribute('class', 'img-close')
//           imgWrapper.appendChild(imgElement)
//           imgWrapper.appendChild(imgClose)

//           setTimeout(function () {
//             imgWrapper.classList.add('img-wrapper__initial')
//             imgElement.classList.add('img-selected-initial')
//           }, 50)

//           out.appendChild(imgWrapper)
//           imgClose.addEventListener('click', function () {
//             container.classList.remove('img-panel__selct')
//             out.removeChild(imgWrapper)
//           })
//         }
//       }
//     }
//   }

//   const update = Id => {
//     // const access_token = localStorage.getItem('token')
//     // const headers = {
//     //   Authorization: `Bearer ${access_token}`
//     // }
//     // axios
//     //   .patch(
//     //     baseUrl + `aadharcard/${Id}`,
//     //     { verified: 'verified' },
//     //     { headers }
//     //   )
//     //   .then(res => {
//     //     All()
//     //   })

//       const access_token = localStorage.getItem('token')
//     const headers = {
//       Authorization: `Bearer ${access_token}`
//     }
//     try {
//       const res = apiRequest(  `aadharcard/${Id}`,"PATCH", { verified: 'verified' },headers)
//       All()
//     } catch (error) {
//       //  console.log(e);
//     } finally {
//       // setLoading(false)
//     }


//   }
//   const dateFormat = e => {
//     const date = new Date(e)
//     const newDate = date.toLocaleString('default', {
//       month: 'long',
//       day: 'numeric',
//       hour: 'numeric',
//       hour12: true,
//       minute: 'numeric'
//     })
//     return newDate
//   }

//   const deletedata = Id => {
//     // const access_token = localStorage.getItem('token')
//     // const headers = {
//     //   Authorization: `Bearer ${access_token}`
//     // }
//     // axios
//     //   .patch(baseUrl + `aadharcard/${Id}`, { verified: 'reject' }, { headers })
//     //   .then(res => {
//     //     All()
//     //   })


      
//       const access_token = localStorage.getItem('token')
//       const headers = {
//         Authorization: `Bearer ${access_token}`
//       }
//     try {
//       const res = apiRequest( `aadharcard/${Id}`, "PATCH",{ verified: 'reject' },headers)
//     if (res) {
//         All()
//     }
//     } catch (error) {
//       //  console.log(e);
//     } finally {
//       // setLoading(false)
//     }
//   }

//   return (
//     <>
//       {/* <h4 className='font-weight-bold my-3'>ALL CHALLANGES</h4> */}
//       <div className='row mt-5'>
//         <div className='col-12 grid-margin'>
//           <div className='card'>
//             <div className='card-body text-light table_bg'>
//               <div className='img-out'></div>
//               <h4 className='dashboard_heading'>KYC</h4>

//               <select
//                 className='form-control col-sm-1 m-1 bg-dark text-light'
//                 id='pagelimit'
//                 name='pagelimit'
//                 onChange={setpageLimit}
//               >
//                 <option value='10'>Set limit</option>
//                 <option value='20'>20</option>
//                 <option value='50'>50</option>
//                 <option value='100'>100</option>
//                 <option value='500'>500</option>
//               </select>
//               <div className='table-responsive'>
//                 <table className='table text-light'>
//                   <thead>
//                     <tr>
//                       <th>#</th>
//                        {
//                           id =="6931311e30989ed52eebce14" ?
//                           <th> ID</th> : ""
//                         }
//                       <th>Profile name</th>
//                       <th>Doc name</th>
//                       <th> Phone</th>
//                       <th> Aadhar no</th>
//                       <th> Address</th>
//                       <th>DOB</th>
//                       <th> Document-Front</th>
//                       <th> Document-Back</th>
//                       <th> status </th>
//                       <th> Date </th>
//                       <th> Approve or Reject </th>
//                       {/* <th> View </th> */}
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {data &&
//                       data.map((item, index) => (
//                         <tr key={index}>
//                           <td>{index + 1}</td>
//                             {
//                           id =="6931311e30989ed52eebce14" ?
//                           <td>{item._id}</td> : ""}
//                           <td>
//                             <Link
//                               type='button'
//                               className='btn btn-primary mx-1'
//                               to={`/user/view_user/${
//                                 item.User ? item.User._id : ''
//                               }`}
//                             >
//                               {item.User ? item.User.Name : ''}
//                             </Link>
//                           </td>
//                           <td>{item.Name}</td>
//                           {admindata?.user?.usertype == 'Admin' ||
//                           admindata?.user?.updateLegalData === true ? (
//                             <td>{item.User?.Phone}</td>
//                           ) : (
//                             <td>{`${
//                               '********' + item.User?.Phone.toString().slice(-2)
//                             }`}</td>
//                           )}
//                           <td>{item.Number}</td>
//                           <td>{item.Address?.replace(/<br>/g, '').slice(0, 150)}</td>
//                           <td>{item.DOB}</td>
//                           <td>
//                             <div className='img-panel'>
//                               <img
//                                 className='img'
//                                 src={baseUrl + `/${item.front}`}
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
//                                 }}
//                                 alt='kyc'
//                                 style={{
//                                   borderRadius: '5px',
//                                   width: '4rem',
//                                   height: '4rem'
//                                 }}
//                                 id={`kyc${index}`}
//                               />
//                             </div>
//                           </td>
//                           <td>
//                             <div className='img-panel'>
//                               <img
//                                 className='img'
//                                 src={baseUrl + `/${item.back}`}
//                                 onError={(e) => {
//                                   e.target.onerror = null;
//                                   e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
//                                 }}
//                                 alt='kyc'
//                                 style={{
//                                   borderRadius: '5px',
//                                   width: '4rem',
//                                   height: '4rem'
//                                 }}
//                                 id={`kyc${index}`}
//                               />
//                             </div>
//                           </td>

//                           <td>{item.verified}</td>
//                           <td>{dateFormat(item.createdAt).split(',')[0]} </td>
//                           <td>
//                             <button
//                               className='btn btn-success mr-1'
//                               onClick={() => update(item._id)}
//                             >
//                               Approve
//                             </button>
//                             <button
//                               className='btn btn-danger'
//                               onClick={() => deletedata(item._id)}
//                             >
//                               Reject 
//                             </button>
//                           </td>
//                           {/* <td><Link to="/user/view" className="btn btn-primary">View</Link></td> */}
//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>

//               <div className='mt-4'>
//                 <ReactPaginate
//                   previousLabel={'Previous'}
//                   nextLabel={'Next'}
//                   breakLabel={'...'}
//                   pageCount={numberOfPages}
//                   marginPagesDisplayed={2}
//                   pageRangeDisplayed={3}
//                   onPageChange={handlePageClick}
//                   containerClassName={'pagination justify-content-center'}
//                   pageClassName={'page-item'}
//                   pageLinkClassName={'page-link'}
//                   previousClassName={'page-item'}
//                   previousLinkClassName={'page-link'}
//                   nextClassName={'page-item'}
//                   nextLinkClassName={'page-link'}
//                   breakClassName={'page-item'}
//                   breakLinkClassName={'page-link'}
//                   activeClassName={'active'}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }


import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import admindata from '../../components/admindata'
import { apiRequest } from '../../apiServices/allApi'
// import './UserKyc.css'

const $ = require('jquery')
$.Datatable = require('datatables.net')

export default function UserKyc () {
  const [data, setData] = useState([])
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const id = localStorage.getItem('id')

  // Pagination states
  let [limit, setLimit] = useState(20)

  const setpageLimit = event => {
    let key = event.target.value
    setLimit(key)
  }
  const [pageNumber, setPageNumber] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)

  const handlePageClick = async data => {
    let currentPage = data.selected + 1
    setPageNumber(currentPage)
  }

  const All = async () => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = await apiRequest(`aadharcard/all/all/all?page=${pageNumber}&_limit=${limit}`, "GET", null, headers)
      setData(res.data.admin)
      setNumberOfPages(res.data.totalPages)
      imageViewer()
    } catch (error) {
    }
  }

  useEffect(() => {
    All()
  }, [pageNumber, limit])

  function imageViewer () {
    let imgs = document.getElementsByClassName('img'),
      out = document.getElementsByClassName('img-out')[0]
    for (let i = 0; i < imgs.length; i++) {
      if (!imgs[i].classList.contains('el')) {
        imgs[i].classList.add('el')
        imgs[i].addEventListener('click', lightImage)
        function lightImage () {
          let container = document.getElementsByClassName('img-panel')[i]
          container.classList.toggle('img-panel__selct')
        }

        imgs[i].addEventListener('click', openImage)
        function openImage () {
          let imgElement = document.createElement('img'),
            imgWrapper = document.createElement('div'),
            imgClose = document.createElement('div'),
            container = document.getElementsByClassName('img-panel')[i]
          container.classList.add('img-panel__selct')
          imgElement.setAttribute('class', 'image__selected')
          imgElement.src = imgs[i].src
          imgWrapper.setAttribute('class', 'img-wrapper')
          imgClose.setAttribute('class', 'img-close')
          imgWrapper.appendChild(imgElement)
          imgWrapper.appendChild(imgClose)

          setTimeout(function () {
            imgWrapper.classList.add('img-wrapper__initial')
            imgElement.classList.add('img-selected-initial')
          }, 50)

          out.appendChild(imgWrapper)
          imgClose.addEventListener('click', function () {
            container.classList.remove('img-panel__selct')
            out.removeChild(imgWrapper)
          })
        }
      }
    }
  }

  const update = Id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = apiRequest(`aadharcard/${Id}`, "PATCH", { verified: 'verified' }, headers)
      All()
    } catch (error) {
    }
  }

  const dateFormat = e => {
    const date = new Date(e)
    const newDate = date.toLocaleString('default', {
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      hour12: true,
      minute: 'numeric'
    })
    return newDate
  }

  const deletedata = Id => {
    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    try {
      const res = apiRequest(`aadharcard/${Id}`, "PATCH", { verified: 'reject' }, headers)
      if (res) {
        All()
      }
    } catch (error) {
    }
  }

  return (
    <div className='userkyc-page-container'>
      <div className='userkyc-main-card'>
        <div className='img-out'></div>
        <h4 className='userkyc-heading-main'>KYC Verification Requests</h4>

        {/* Filter Controls Bar */}
        <div className='userkyc-filter-bar'>
          <select
            className='custom-userkyc-select'
            id='pagelimit'
            name='pagelimit'
            onChange={setpageLimit}
          >
            <option value='10'>Limit: 10</option>
            <option value='20'>Limit: 20</option>
            <option value='50'>Limit: 50</option>
            <option value='100'>Limit: 100</option>
            <option value='500'>Limit: 500</option>
          </select>
        </div>

        {/* Responsive Table Content */}
        <div className='table-responsive-wrapper'>
          <table className='userkyc-modern-table'>
            <thead>
              <tr>
                <th>#</th>
                {id == "6931311e30989ed52eebce14" && <th>ID</th>}
                <th>Profile Name</th>
                <th>Doc Name</th>
                <th>Phone</th>
                <th>Identity Document</th>
                <th>Address</th>
                <th>DOB</th>
                <th>Document Front</th>
                <th>Document Back</th>
                <th>Status</th>
                <th>Date</th>
                <th>Approve or Reject</th>
              </tr>
            </thead>

            <tbody>
              {data &&
                data.map((item, index) => (
                  <tr key={item._id || index}>
                    <td>{index + 1}</td>

                    {id == "6931311e30989ed52eebce14" && (
                      <td style={{ fontFamily: 'monospace', color: '#a5b4fc' }}>{item._id}</td>
                    )}

                    <td>
                      <Link
                        className='user-profile-link'
                        to={`/user/view_user/${item.User ? item.User._id : ''}`}
                      >
                        {item.User ? item.User.Name : 'N/A'}
                      </Link>
                    </td>

                    <td style={{ fontWeight: 600 }}>{item.Name}</td>

                    <td style={{ color: '#34d399', fontWeight: 600 }}>
                      {admindata?.user?.usertype == 'Admin' ||
                      admindata?.user?.updateLegalData === true ? (
                        <span>{item.User?.Phone}</span>
                      ) : (
                        <span>{`${'********' + item.User?.Phone?.toString().slice(-2)}`}</span>
                      )}
                    </td>

                    <td style={{ fontFamily: 'monospace', color: '#38bdf8' }}>
                      [Identity Document Redacted]
                    </td>

                    <td style={{ color: '#cbd5e1' }}>
                      {item.Address?.replace(/<br>/g, '').slice(0, 150)}
                    </td>

                    <td>{item.DOB}</td>

                    <td>
                      <div className='img-panel'>
                        <img
                          className='img kyc-doc-thumb'
                          src={baseUrl + `/${item.front}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
                          }}
                          alt='KYC Front'
                          id={`kyc${index}`}
                        />
                      </div>
                    </td>

                    <td>
                      <div className='img-panel'>
                        <img
                          className='img kyc-doc-thumb'
                          src={baseUrl + `/${item.back}`}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
                          }}
                          alt='KYC Back'
                          id={`kyc${index}`}
                        />
                      </div>
                    </td>

                    <td style={{
                      fontWeight: 700,
                      color: item.verified === 'verified' ? '#34d399' : item.verified === 'reject' ? '#f87171' : '#f59e0b'
                    }}>
                      {item.verified}
                    </td>

                    <td>{dateFormat(item.createdAt).split(',')[0]}</td>

                    <td>
                      <div className='btn-action-group'>
                        <button
                          className='btn-kyc-approve'
                          onClick={() => update(item._id)}
                        >
                          Approve
                        </button>
                        <button
                          className='btn-kyc-reject'
                          onClick={() => deletedata(item._id)}
                        >
                          Reject
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Wrapper */}
        <div className='pagination-container'>
          <ReactPaginate
            previousLabel={'Previous'}
            nextLabel={'Next'}
            breakLabel={'...'}
            pageCount={numberOfPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination justify-content-center'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            activeClassName={'active'}
          />
        </div>

      </div>
    </div>
  )
}